import styles from "./BillingsHeader.module.scss";

export const BillingsHeader: React.FC = () => {
  return <div className={styles.controls}></div>;
};
